import { Component } from '@angular/core';
import { RbacService } from '../../../shared/services/rbac.service';

@Component({
  selector: 'app-home-page',
  standalone: false,
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent { 
  constructor(
    public rbacService: RbacService
  ) {}
}
